import React, { useRef, useEffect } from "react";
import { Bold, Italic, Underline, List, ListOrdered, Link2, Undo } from "lucide-react";
import { sanitizeRichText } from "@/lib/content";

const Btn = ({ onClick, children, title, testid }) => (
  <button
    data-testid={`${testid}-${title.toLowerCase().replaceAll(" ", "-")}-button`}
    type="button"
    title={title}
    onMouseDown={(e) => e.preventDefault()}
    onClick={onClick}
    className="flex h-8 w-8 items-center justify-center rounded-sm text-navy transition-colors hover:bg-navy hover:text-white"
  >
    {children}
  </button>
);

export const RichTextEditor = ({ value, onChange, testid }) => {
  const ref = useRef(null);

  useEffect(() => {
    const safeValue = sanitizeRichText(value);
    if (ref.current && ref.current.innerHTML !== safeValue) {
      ref.current.innerHTML = safeValue;
    }
  }, [value]);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    if (ref.current) onChange(sanitizeRichText(ref.current.innerHTML));
  };

  const addLink = () => {
    const url = window.prompt("Enter URL");
    if (url) exec("createLink", url);
  };

  return (
    <div className="rounded-sm border border-input bg-white">
      <div className="flex flex-wrap items-center gap-1 border-b border-input p-1.5">
        <Btn testid={testid} title="Bold" onClick={() => exec("bold")}><Bold className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Italic" onClick={() => exec("italic")}><Italic className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Underline" onClick={() => exec("underline")}><Underline className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Bullet List" onClick={() => exec("insertUnorderedList")}><List className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Numbered List" onClick={() => exec("insertOrderedList")}><ListOrdered className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Link" onClick={addLink}><Link2 className="h-4 w-4" /></Btn>
        <Btn testid={testid} title="Undo" onClick={() => exec("undo")}><Undo className="h-4 w-4" /></Btn>
      </div>
      <div
        ref={ref}
        data-testid={testid}
        contentEditable
        onInput={(e) => onChange(sanitizeRichText(e.currentTarget.innerHTML))}
        className="prose prose-sm min-h-[140px] max-w-none p-3 text-sm focus:outline-none"
        suppressContentEditableWarning
      />
    </div>
  );
};

export default RichTextEditor;
